<template>
  <div>
    <div v-if="!noWrap" class="v2-overlay-wrap">
      <slot />
      <div v-if="show" class="v2-overlay">
        <div v-if="bgEnabled" class="background" :class="{ 'rounded-1': bgRounded }" />
        <slot name="overlay">
          <div :class="`spinner spinner-border text-${variant}`" role="status" />
        </slot>
      </div>
    </div>
    <div v-else-if="show" class="v2-overlay" :class="{ 'position-fixed': fixed }">
      <div v-if="bgEnabled" class="background" :class="{ 'rounded-1': bgRounded }" />
      <slot name="overlay">
        <div :class="`spinner-border text-${variant}`" role="status" />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "app-overlay",
});

defineSlots<{
  default?: () => unknown;
  overlay?: () => unknown;
}>();

defineProps({
  variant: {
    type: String,
    default: "dark",
  },
  noWrap: {
    type: Boolean,
    default: false,
  },
  fixed: {
    type: Boolean,
    default: false,
  },
  bgEnabled: {
    type: Boolean,
    default: false,
  },
  bgRounded: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
